module.exports = __webpack_public_path__ + "img/xinwu.57ca7672.png";